import * as Yup from 'yup';

export default Yup.object().shape({
  otherDoc: Yup.string().when('docType', {
    is: 'Other',
    then: Yup.string().min(3, 'Too short').required('Please enter the document type')
  })
});
